"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleEvent = void 0;
/**
 * Вызывает обработчик если он есть и не падает если его нет
 */

function handleEvent(callback) {
  var values = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    values[_i - 1] = arguments[_i];
  }

  if (callback) {
    callback.apply(void 0, values);
  }
}

exports.handleEvent = handleEvent;